import { HttpTypes } from "@medusajs/types"

export function getLocalizedGenericMember(target: any, field: string, locale: string): string {
  if (!target) {
    return ""
  }
  // Try to get the localized value from metadata, e.g., "hr.field"
  const localized = target?.metadata?.[`${locale}.${field}`] as string
  return localized ?? target[field]
}

export function getLocalizedTitle(target: { title: string, metadata?: Record<string, unknown> | null }, locale: string): string {
  // Try to get the localized title from metadata, e.g., "hr.title"
  return getLocalizedGenericMember(target, "title", locale)
}

export function getLocalizedName(
  target: { name: string, metadata?: Record<string, unknown> | null },
  locale: string
): string {
  return getLocalizedGenericMember(target, "name", locale)
}